import type { UserMiniEntity } from "@/features/user/domain/entities/UserMiniEntity";
import type { ServiceMiniEntity } from "@/features/service/domain/entities/ServiceMiniEntity";
export class CompaniesFilterEntity {
  id?: number
  service?:   ServiceMiniEntity
  name?: string
  user?: UserMiniEntity
  page?: number
  limit?: number
  sortField?: string
  sortDescending?: boolean
}
